import { useTranslation } from "react-i18next";
import { MessageCircle, Facebook, Send, Twitter } from "lucide-react";

const ShareButtons = ({ title, url }) => {
  const { t } = useTranslation();
  const u = encodeURIComponent(url);
  const txt = encodeURIComponent(`${title} 🚀`);
  const links = [
    { id: "whatsapp", icon: MessageCircle, href: `https://wa.me/?text=${txt}%20${u}`, label: "WhatsApp", cls: "hover:bg-[#25D366]" },
    { id: "facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${u}`, label: "Facebook", cls: "hover:bg-[#1877F2]" },
    { id: "x", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${txt}&url=${u}`, label: "X", cls: "hover:bg-black" },
    { id: "telegram", icon: Send, href: `https://t.me/share/url?url=${u}&text=${txt}`, label: "Telegram", cls: "hover:bg-[#229ED9]" },
  ];
  return (
    <div data-testid="share-buttons" className="mt-8 pt-6 border-t border-zinc-300">
      <div className="text-xs uppercase tracking-wider text-zinc-500 font-semibold mb-3">
        {t("share.label")}
      </div>
      <div className="flex gap-2">
        {links.map((l) => (
          <a
            key={l.id}
            data-testid={`share-${l.id}`}
            href={l.href}
            target="_blank"
            rel="noreferrer"
            aria-label={l.label}
            className={`w-10 h-10 border border-zinc-300 flex items-center justify-center transition hover:text-white hover:border-transparent ${l.cls}`}
          >
            <l.icon className="w-4 h-4" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default ShareButtons;
